import{a as r}from"./_curry2-12509879.js";var a=r((function(r,a){for(var n={},o=0;o<r.length;)r[o]in a&&(n[r[o]]=a[r[o]]),o+=1;return n}));export{a as _};
